import { useFileMessageSenderState } from "@/zustand/FileMessageSenderState";
import { formatFileSize } from "@/lib/utils";

import { File } from "lucide-react";
import { Button } from "@/components/primitives/button";
import { CircleX } from "lucide-react";
import { useMediaMessageSenderState } from "@/zustand/MediaMessageSenderState";
import { useEffect } from "react";
import { TruncatedFilename } from "@/components/primitives/TruncatedFilename";

export default function FileAttachmentPreview() {
  const { newFileAttachment, discardFileAttachment } =
    useFileMessageSenderState();

  const discardMediaAttachment =
    useMediaMessageSenderState().discardMediaAttachment;

  useEffect(() => {
    if (!newFileAttachment) {
      return;
    }
    discardMediaAttachment();
  }, [newFileAttachment, discardMediaAttachment]);

  if (!newFileAttachment) {
    return null;
  }

  return (
    <div className="flex w-full max-w-96">
      <div className="relative my-1 flex w-full min-w-0 select-none items-center gap-2 rounded-md bg-muted/30 px-3 py-2 hover:bg-muted/50">
        <div className="flex min-w-0 flex-1 gap-3 overflow-hidden">
          <File className="size-8 shrink-0 sm:size-10" />
          <div className="flex w-0 flex-1 flex-col">
            <TruncatedFilename
              filename={newFileAttachment.name}
              className="text-sm font-normal leading-tight sm:text-base"
            />
            <div className="truncate text-xs opacity-30">
              {formatFileSize(newFileAttachment.size)}
            </div>
          </div>
        </div>

        <Button
          size="icon"
          variant="ghost"
          onClick={discardFileAttachment}
          className="size-5 shrink-0 rounded-full bg-muted"
        >
          <CircleX />
        </Button>
      </div>
    </div>
  );
}
